"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.peekPayload = void 0;
function peekPayload(token) {
    const payloadBase64Url = token.split('.')[1];
    const payloadBase64 = payloadBase64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(payloadBase64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join(''));
    return JSON.parse(jsonPayload);
}
exports.peekPayload = peekPayload;
